import ProductsHeader from "./ProductsHeader";

export default ProductsHeader;
